import React, { useState, useEffect } from "react";
import useRanking from "../../hooks/useRanking";
import useUser from "../../hooks/useUser";
import toast, { Toaster } from "react-hot-toast";
import {
  Grid,
  GridColumn,
  GridToolbar,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { filterBy } from "@progress/kendo-data-query";
import "@progress/kendo-theme-default/dist/all.css";
import { formatNumber } from "../../utils/format";
import useKendoGridState from "../../hooks/useKendoGridState";

const PageTemplate = (props) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "10px",
        left: "10px",
      }}
    >
      Page {props.pageNum} of {props.totalPages}
    </div>
  );
};

// obtener mes actual
const mesActual = () => {
  let meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  let d = new Date();
  let m = d.getMonth();
  return meses[m];
};

export default function Ventas() {
  const {
    success,
    message,
    error,
    Lugares,
    SeccionesGetService,
    RankingAddService,
  } = useRanking();
  const { tokenFull, IdUser, Roles, Dealer } = useUser();
  const [Desde, setDesde] = useState("");
  const [Hasta, setHasta] = useState("");
  const { sort, setSort, filter, setFilter, page, setPage, pageChange } = useKendoGridState("folio", "desc");

  const ENDPOINT = process.env.REACT_APP_BASE_URL;

  const _export = React.useRef(null);

  const _pdfExport = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  const exportPDF = () => {
    if (_pdfExport.current !== null) {
      _pdfExport.current.save();
    }
  };

  useEffect(() => {
    SeccionesGetService(tokenFull, 'MX03');
  }, [SeccionesGetService]);

  const ProductosAgregados = () => {
    toast.loading("Registrando...");
    const data = new FormData();
    data.append("rol", Roles);
    data.append("user_id", IdUser);
    data.append("desde", Desde);

    RankingAddService(data, tokenFull);
  };

  useEffect(() => {
    if (success) {
      toast.dismiss();
      toast.success(message);
    }
  }, [message, success]);

  return (
    <>
      <Toaster />
      <h2 className="titulo2">Ranking actual de la región Sur</h2>
      <br />
      <div className="row">
        <div className="col-md-12">
          <Grid
            sortable={true}
            sort={sort}
            onSortChange={(e) => {
              setSort(e.sort);
            }}
            filterable={true}
            filter={filter}
            onFilterChange={(e) => setFilter(e.filter)}
            pageable={true}
            data={filterBy(
                Lugares.slice(page.skip, page.take + page.skip),
              filter
            )}
            skip={page.skip}
            take={page.take}
            total={Lugares.length}
            onPageChange={pageChange}
            style={{
              height: "620px",
            }}
          >
            <GridNoRecords>No hay informacion disponible</GridNoRecords>
            <GridColumn
              field="Lugar"
              filter="text"
              format={null}
              cell={(e) => {
                let lugar = e.dataIndex + 1;
                return <td style={lugar < 3 ? {marginTop: 10, background: '#ccc'} : {marginTop: 10}}>{lugar}</td>;
              }}
            />
            <GridColumn
              field="Vendedor"
              filter="text"
              format={null}
              cell={(e) => {
                let nombre =
                  e.dataItem.nombre +
                  " " +
                  e.dataItem.apellido_paterno +
                  " " +
                  e.dataItem.apellido_materno;
                  let lugar = e.dataIndex + 1;
                return <td style={lugar < 3 ? {marginTop: 10, background: '#ccc'} : {marginTop: 10}}>{nombre}</td>;
              }}
            />
            <GridColumn
              field="Puntos"
              filter="text"
              format={null}
              cell={(e) => {
                let total = e.dataItem.puntos;
                let lugar = e.dataIndex + 1;
                return (
                  <td style={lugar < 3 ? {marginTop: 10, background: '#ccc', textAlign: "right"} : {marginTop: 10, textAlign: "right"}}>{total}</td>
                );
              }}
            />
            {Roles == "Admin" ? (
            <GridColumn
              field="Monto"
              filter="text"
              format={null}
              cell={(e) => {
                let lugar = e.dataIndex + 1;
                let monto = 0;
                if (lugar >= 1 && lugar <= 2) {
                  monto = 500;
                }
                let lugarr = e.dataIndex + 1;
                return (
                  <td style={lugarr < 3 ? {marginTop: 10, background: '#ccc', textAlign: "right"} : {marginTop: 10, textAlign: "right"}}>
                    {"$" + formatNumber(monto)}
                  </td>
                );
              }}
            />
            ) : (
              ""
            )}
          </Grid>
        </div>
      </div>
    </>
  );
}
